var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.58C36.1945 47.58 45.08 38.6944 45.08 26.5C45.08 14.3055 36.1945 5.42 24 5.42C11.8056 5.42 2.92 14.3055 2.92 26.5C2.92 38.6944 11.8056 47.58 24 47.58ZM24 49.5C37.2549 49.5 47 39.7548 47 26.5C47 13.2452 37.2549 3.5 24 3.5C10.7452 3.5 1 13.2452 1 26.5C1 39.7548 10.7452 49.5 24 49.5Z",
    fill: "#71AAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6418 8.50998L43.8468 6.69597C45.5253 4.99978 48.2464 4.99978 49.9248 6.69597C51.6032 8.39217 51.6032 11.1423 49.9248 12.8385L40.7093 22.1517C39.0309 23.8479 36.3097 23.8479 34.6313 22.1517L30.4424 17.9184C28.764 16.2222 28.764 13.4721 30.4424 11.7759L32.2373 13.5899C31.5503 14.2843 31.5503 15.41 32.2373 16.1044L36.4262 20.3377C37.1133 21.032 38.2273 21.032 38.9143 20.3377L48.1299 11.0244C48.817 10.3301 48.817 9.20432 48.1299 8.50998C47.4428 7.81563 46.3289 7.81563 45.6418 8.50998ZM37.6703 12.938L43.8468 6.69597L45.6418 8.50998L37.6703 16.566L34.7254 13.5899C34.0383 12.8956 32.9244 12.8956 32.2373 13.5899L30.4424 11.7759C32.1208 10.0798 34.842 10.0798 36.5204 11.7759L37.6703 12.938Z",
    fill: "#1C2A34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1303 8.51002C48.8174 9.20437 48.8174 10.3301 48.1303 11.0245L38.9147 20.3377C38.2277 21.0321 37.1137 21.0321 36.4267 20.3377L32.2378 16.1044C31.5507 15.4101 31.5507 14.2843 32.2378 13.59C32.9249 12.8957 34.0388 12.8957 34.7259 13.59L37.6707 16.566L45.6422 8.51002C46.3293 7.81567 47.4432 7.81567 48.1303 8.51002Z",
    fill: "#71AAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7378 9.32416C46.917 9.50667 46.9158 9.80142 46.7352 9.98251L39.966 16.7702C39.7854 16.9512 39.4937 16.9501 39.3146 16.7676C39.1354 16.5851 39.1365 16.2903 39.3171 16.1092L46.0864 9.32159C46.2669 9.1405 46.5586 9.14166 46.7378 9.32416Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5236 14.2641C33.7014 14.0803 33.9931 14.0769 34.175 14.2566L35.0065 15.0781C35.1884 15.2578 35.1918 15.5526 35.0139 15.7364C34.8361 15.9203 34.5445 15.9236 34.3625 15.7439L33.531 14.9224C33.3491 14.7427 33.3458 14.448 33.5236 14.2641Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerNav);
export default __webpack_public_path__ + "static/media/PARTNER-nav.4820b26d3779d0f71b335ab47e31c60d.svg";
export { ForwardRef as ReactComponent };